var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecallsRemedyWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recall-remedy-warning"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C12.7294 0 13.4009 0.397066 13.7524 1.03616L23.7524 19.218C24.0932 19.8376 24.0815 20.5911 23.7216 21.1997C23.3617 21.8084 22.7071 22.1818 22 22.1818H2C1.29288 22.1818 0.638317 21.8084 0.27842 21.1997C-0.0814762 20.5911 -0.0932064 19.8376 0.247568 19.218L10.2476 1.03616C10.5991 0.397066 11.2706 0 12 0ZM3.1 18.1818L2 20.1818H4.28254H19.7175H22L20.9 18.1818L13.1413 4.07504L12 2L10.8587 4.07504L3.1 18.1818Z",
    fill: "#B16201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 20.1818L12 2L22 20.1818H2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9915 14.8559L10.6525 6.5H13.3644L13.0254 14.8559H10.9915ZM10.5 17.6356C10.5 16.822 11.178 16.1441 12.0085 16.1441C12.822 16.1441 13.5 16.822 13.5 17.6356C13.5 18.4661 12.822 19.1441 12.0085 19.1441C11.178 19.1441 10.5 18.4661 10.5 17.6356Z",
    fill: "#B16201"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecallsRemedyWarning);
export default __webpack_public_path__ + "static/media/recalls-remedy-warning.2a6c47d5d7ad5812fb0778332ed32469.svg";
export { ForwardRef as ReactComponent };